export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "Gästebewertungen",
    subtitle: "Bitten Sie am Check-out-Tag per WhatsApp um eine Bewertung. Legen Sie den Link fest, unter dem Ihre Gäste ihr Feedback hinterlassen sollen.",
    bulkNotice: "Diese Änderung gilt für alle {count} Unterkünfte, die mit diesem Inserat verknüpft sind.",
    enableTitle: "Gästebewertungen aktivieren",
    enableSub: "Am Check-out-Tag wird automatisch eine WhatsApp-Nachricht mit der Bitte um eine Bewertung gesendet.",
    modeSingleTitle: "Ein einziger Link",
    modeSingleSub: "Derselbe für jede Buchung",
    modePerOtaTitle: "Ein Link pro OTA",
    modePerOtaSub: "Je nach Buchungskanal",
    linkLabel: "Bewertungslink",
    singleUrlPlaceholder: "https://g.page/r/… oder der Link zu Ihrer Bewertungsseite",
    otaNamePlaceholder: "Name der Website",
    otaUrlPlaceholder: "https://… Bewertungslink",
    removeTitle: "Entfernen",
    addOta: "Weitere Website hinzufügen",
    saving: "Wird gespeichert…",
    saveConfig: "Einstellungen speichern",
    note: "Gäste erhalten den passenden Link, je nachdem, wie sie gebucht haben.",
    toastLoadError: "Die Daten des Inserats konnten nicht geladen werden.",
    urlErrorProtocol: "Die URL muss mit http:// oder https:// beginnen",
    urlErrorInvalid: "Geben Sie eine gültige URL ein (z. B. https://g.page/...)",
    toastStateUpdated: "Status erfolgreich aktualisiert",
    toastStateError: "Beim Aktualisieren des Status ist etwas schiefgelaufen",
    toastUrlRequired: "Geben Sie vor dem Speichern eine URL ein",
    toastSaved: "Einstellungen erfolgreich gespeichert",
    toastSaveError: "Beim Speichern ist etwas schiefgelaufen",
  },

  // AccessSummary.vue
  access: {
    tag: "Schlösser & Zugang",
    dynamicTitle: "Smartes Schloss verbunden",
    dynamicDetail: "Für jede Buchung wird automatisch ein neuer Code erzeugt und an den Gast gesendet.",
    chipCheckin: "Wird nach Abschluss des Check-ins gesendet",
    chipTime: "Wird am Anreisetag um {time} gesendet",
    chipManual: "Sie senden ihn manuell",
    staticTitle: "Schloss mit festem Code",
    staticDetail: "Der Gast erhält den Code für den Schlüsseltresor oder das Schloss, um hineinzukommen.",
    noneTitle: "Ich übergebe die Schlüssel persönlich",
    noneDetail: "Sie vereinbaren die Schlüsselübergabe bei der Ankunft direkt mit dem Gast.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "Preis aktualisieren",
    saving: "Wird gespeichert…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "Verknüpfen Sie jede Einheit dieses Inserats mit ihrem Mossos-Betrieb (jede Einheit kann eine eigene Polizeikennung haben). Check-ins werden anhand der Einheit der Buchung automatisch an den richtigen Betrieb gesendet.",
    wholeListing: "Gesamtes Inserat",
    wholeListingDefault: "Gesamtes Inserat (Standard)",
    unitNumber: "Einheit #{id}",
    badgeSendError: "Sendefehler",
    badgeConnected: "Verbunden",
    badgeNoCredentials: "Keine Zugangsdaten",
    emptyList: "Noch keine Verbindungen. Fügen Sie für jede Einheit des Inserats eine hinzu.",
    addConnection: "Verbindung hinzufügen",
    editConnection: "Verbindung bearbeiten",
    newConnection: "Neue Verbindung",
    unit: "Einheit",
    unitPlaceholder: "Einheit auswählen",
    unitHint: "Zu welcher Einheit des Inserats dieser Betrieb gehört.",
    step1Title: "Zugang zur Mossos-Website",
    usuariLabel: "Usuari (Mossos-Website)",
    savedHint: "gespeichert",
    usuariPlaceholderKeep: "Leer lassen, um ihn beizubehalten",
    usuariPlaceholderNew: "Benutzername für die Anmeldung auf der Website",
    passLabel: "Paraula de pas",
    passBlankHint: "leer lassen, um es beizubehalten",
    passPlaceholder: "Passwort der Mossos-Website",
    validateHint: "Validieren Sie, um die Betriebe in Ihrem Konto abzurufen.",
    searching: "Wird gesucht…",
    validateSearch: "Validieren und Betriebe suchen",
    step2Title: "Betrieb für diese Einheit",
    establishmentPlaceholder: "Betrieb auswählen",
    revalidateHint: "Validieren Sie erneut, um ihn zu ändern.",
    validateAbove: "Validieren Sie oben, um den Betrieb für diese Einheit auszuwählen.",
    checkinTime: "Abrechnungszeit (Ankunft)",
    checkoutTime: "Abreisezeit",
    cancel: "Abbrechen",
    savingBtn: "Wird gespeichert...",
    updateConnection: "Verbindung aktualisieren",
    saveConnection: "Verbindung speichern",
    warnCredentials: "Geben Sie den usuari und die paraula de pas für die Mossos-Website ein.",
    foundEstablishments: "{count} Betrieb(e) gefunden. Wählen Sie den für diese Einheit aus.",
    noEstablishments: "In diesem Konto wurden keine Betriebe gefunden.",
    connectError: "Verbindung zu Mossos nicht möglich. Prüfen Sie Ihren usuari und Ihr Passwort.",
    validateFirst: "Validieren Sie und wählen Sie den Betrieb für diese Verbindung aus.",
    savedOk: "Mossos-Verbindung gespeichert.",
    saveError: "Die Verbindung konnte nicht gespeichert werden.",
    saveErrorGeneric: "Fehler beim Speichern der Mossos-Verbindung.",
    confirmDelete: `Verbindung für „{unit}“ ({id}) löschen?`,
    deletedOk: "Verbindung gelöscht.",
    deleteError: "Die Verbindung konnte nicht gelöscht werden.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "Jede Einheit meldet ihre Gäste über ein SES-Hospedajes-Konto. Sie können ein einziges Konto für das gesamte Inserat verwenden oder einigen Einheiten ein anderes zuweisen, zum Beispiel wenn jedes Apartment einen eigenen Betriebscode hat.",
    defaultName: "Betrieb {code}",
    badgeConnected: "Verbunden",
    badgeError: "Validierungsfehler",
    badgePending: "Nicht validiert",
    user: "Benutzer",
    lessor: "Vermieter",
    establishment: "Betrieb",
    appliesWhole: "Gesamtes Inserat:",
    appliesUnits: "Einheiten:",
    noUnits: "Keine Einheit nutzt es",
    allUnits: "Alle Einheiten ({count})",
    moreUnits: "+{count} weitere",
    andMore: "und {count} weitere",
    emptyList: "Sie haben noch kein SES-Hospedajes-Konto verbunden.",
    withoutAccountTitle: "Ohne Konto:",
    withoutAccountText: "Ihre Check-ins werden nicht an SES Hospedajes gemeldet.",
    addAccount: "Konto hinzufügen",
    edit: "Bearbeiten",
    remove: "Entfernen",
    newTitle: "Neues SES-Hospedajes-Konto",
    editTitle: "SES-Hospedajes-Konto bearbeiten",
    aliasLabel: "Name des Kontos (optional)",
    aliasPlaceholder: "z. B. Penthouses, Apartment 2B",
    aliasHint: "Dient nur dazu, es hier zu erkennen. Bleibt es leer, wird das Konto mit seinem Betriebscode angezeigt.",
    loginTitle: "Zugang zum Ministerium",
    loginSame: "Derselbe Benutzer und dasselbe Passwort",
    loginSameHint: "Sie geben nur die Codes dieses Kontos ein.",
    loginOwn: "Anderer Benutzer und anderes Passwort",
    loginFrom: "Zugang übernehmen von",
    passwordKeep: "Leer lassen, um es nicht zu ändern",
    passwordNeeded: "Geben Sie das Passwort des neuen Benutzers ein.",
    passwordShared: "Diesen Benutzer verwenden {count} weitere Konten des Inserats: Wenn Sie das Passwort ändern, wird es in allen aktualisiert.",
    scopeTitle: "Für welche Einheiten gilt es?",
    scopeWhole: "Gesamtes Inserat",
    scopeWholeHint: "Wird von den Einheiten genutzt, die kein anderes Konto haben.",
    scopeWholeTaken: "Das ist bereits „{name}“.",
    scopeUnits: "Nur einige Einheiten",
    scopeUnitsHint: "Sie wählen aus, welche.",
    unitNow: "jetzt: {name}",
    unitNowWhole: "jetzt: das des gesamten Inserats",
    unitNowNone: "ohne Konto",
    leftWithout: "nach dem Speichern ohne Konto. Ihre Check-ins werden nicht mehr an SES Hospedajes gemeldet.",
    leftToWhole: "nach dem Speichern erfolgt die Meldung über das Konto des gesamten Inserats „{name}“.",
    errUnits: "Wählen Sie mindestens eine Einheit.",
    errDefaultExists: "Dieses Inserat hat bereits ein Konto für alle seine Einheiten.",
    errDuplicate: "Dieses Konto gibt es in diesem Inserat schon. Bearbeiten Sie es und fügen Sie Einheiten hinzu.",
    errCopyFrom: "Der Zugang dieses Kontos konnte nicht übernommen werden. Geben Sie ihn manuell ein.",
    savedValidated: "Konto gespeichert und vom Ministerium validiert.",
    savedNotValidated: "Gespeichert, aber das Ministerium lehnt die Daten ab. Bitte prüfen.",
    savedUnchecked: "Konto gespeichert. TRA kann den Token nicht vorab prüfen: Das zeigt sich bei der ersten Übermittlung.",
    passwordSynced: "Passwort auch in {count} Konto/Konten mit demselben Benutzer aktualisiert.",
    removeTitle: "Dieses Konto entfernen?",
    removeNoUnits: "Das Konto „{name}“ wird entfernt. Keine Einheit nutzt es.",
    removeToFallback: "„{name}“ wird entfernt. Die Einheiten, die es nutzen ({units}), melden dann über das Konto des gesamten Inserats „{fallback}“.",
    removeToNothing: "„{name}“ wird entfernt. Die Einheiten, die es nutzen ({units}), haben dann kein Konto mehr und ihre Check-ins werden nicht mehr an SES Hospedajes gemeldet.",
    removeConfirm: "Ja, entfernen",
    removed: "Konto entfernt.",
    removeError: "Das Konto konnte nicht entfernt werden.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "Konten werden geladen…",
    saving: "Wird gespeichert…",
    close: "Schließen",
    show: "Anzeigen",
    hide: "Ausblenden",

    badgeConnected: "Verbunden",
    badgeError: "Validierungsfehler",
    badgePending: "Nicht validiert",
    badgeOnSend: "Wird beim Senden geprüft",

    edit: "Bearbeiten",
    remove: "Entfernen",
    addAccount: "Konto hinzufügen",

    appliesWhole: "Gesamtes Inserat:",
    appliesUnits: "Einheiten:",
    noUnits: "Keine Einheit nutzt es",
    allUnits: "Alle Einheiten ({count})",
    moreUnits: "+{count} weitere",
    andMore: "und {count} weitere",
    withoutAccountTitle: "Ohne Konto:",

    scopeTitle: "Für welche Einheiten gilt es?",
    scopeWhole: "Gesamtes Inserat",
    scopeWholeHint: "Wird von den Einheiten genutzt, die kein anderes Konto haben.",
    scopeWholeTaken: "Das ist bereits „{name}“.",
    scopeUnits: "Nur einige Einheiten",
    scopeUnitsHint: "Sie wählen aus, welche.",
    unitNow: "jetzt: {name}",
    unitNowWhole: "jetzt: das des gesamten Inserats",
    unitNowNone: "ohne Konto",
    leftToWhole: "nach dem Speichern erfolgt die Meldung über das Konto des gesamten Inserats „{name}“.",

    aliasLabel: "Name des Kontos (optional)",
    aliasPlaceholder: "z. B. Nordturm, Apartment 301",
    loginFrom: "Zugang übernehmen von",
    secretKeep: "Leer lassen, um ihn nicht zu ändern",

    errUnits: "Wählen Sie mindestens eine Einheit.",
    errDefaultExists: "Dieses Inserat hat bereits ein Konto für alle seine Einheiten.",
    errDuplicate: "Dieses Konto gibt es in diesem Inserat schon. Bearbeiten Sie es und fügen Sie Einheiten hinzu.",
    errCopyFrom: "Der Zugang dieses Kontos konnte nicht übernommen werden. Geben Sie ihn manuell ein.",
    errNoListing: "Wir finden das Inserat nicht. Öffnen Sie den Bildschirm erneut.",
    saveError: "Das Konto konnte nicht gespeichert werden.",

    removeTitle: "Dieses Konto entfernen?",
    removeConfirm: "Ja, entfernen",
    removeNoUnits: "Das Konto „{name}“ wird entfernt. Keine Einheit nutzt es.",
    removeToFallback: "„{name}“ wird entfernt. Die Einheiten, die es nutzen ({units}), melden dann über das Konto des gesamten Inserats „{fallback}“.",
    removeToNothing: "„{name}“ wird entfernt. Die Einheiten, die es nutzen ({units}), haben dann kein Konto mehr und melden nicht mehr an {authority}.",
    removed: "Konto entfernt.",
    removeError: "Das Konto konnte nicht entfernt werden.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "Jede Einheit meldet ihre Gäste über ein Konto an SIRE. Sie können ein einziges Konto für das gesamte Inserat verwenden oder einigen Einheiten ein anderes zuweisen, zum Beispiel wenn jedes Apartment mit einem eigenen Betriebscode angemeldet ist.",
      introSingle: "Verbinden Sie das Konto, über das dieses Inserat seine Gäste an SIRE meldet.",
      emptyList: "Sie haben noch kein SIRE-Konto verbunden.",
      withoutAccountText: "Ihre Check-ins werden nicht an SIRE gemeldet.",
      newTitle: "Neues SIRE-Konto",
      editTitle: "SIRE-Konto bearbeiten",
      modalSub: "Das sind die Daten, mit denen Sie sich bei SIRE anmelden",
      defaultName: "Betrieb {code}",
      defaultNameDoc: "Dokument {document}",
      docTypeLabel: "Dokumentart",
      docType_CO_ID: "Personalausweis für Staatsangehörige (cédula de ciudadanía)",
      docType_CO_FID: "Ausweis für Ausländer (cédula de extranjería)",
      documentLabel: "Dokumentnummer",
      documentPlaceholder: "z. B. 1012345678",
      documentHint: "Das ist der Benutzer, mit dem Sie sich bei SIRE anmelden.",
      passwordLabel: "Passwort",
      passwordPlaceholder: "Das Passwort für SIRE",
      passwordShared: "Dieses Dokument verwenden {count} weitere Konten des Inserats: Wenn Sie das Passwort ändern, wird es in allen aktualisiert.",
      estLabel: "Betriebscode (optional)",
      estPlaceholder: "z. B. 67890",
      estHint: "Nur nötig, wenn Sie mit demselben Zugang mehrere Unterkünfte melden. Bleibt es leer, wird der Code verwendet, den Sie angemeldet haben.",
      loginTitle: "Zugang zu SIRE",
      loginSame: "Dasselbe Dokument und dasselbe Passwort",
      loginSameHint: "Sie geben nur den Code dieses Kontos ein.",
      loginOwn: "Anderes Dokument und anderes Passwort",
      aliasHint: "Dient nur dazu, es hier zu erkennen. Bleibt es leer, wird das Konto mit seinem Betriebscode angezeigt.",
      metaDoc: "Dokument",
      metaEst: "Betrieb",
      leftWithout: "nach dem Speichern ohne Konto. Ihre Check-ins werden nicht mehr an SIRE gemeldet.",
      errDocument: "Geben Sie die Dokumentnummer ein.",
      errPassword: "Geben Sie das Passwort für SIRE ein.",
      errPasswordNeeded: "Geben Sie das Passwort des neuen Dokuments ein.",
      savedValidated: "Konto gespeichert und von SIRE validiert.",
      savedNotValidated: "Gespeichert, aber SIRE lehnt die Daten ab. Bitte prüfen.",
      savedUnchecked: "Konto gespeichert. TRA kann den Token nicht vorab prüfen: Das zeigt sich bei der ersten Übermittlung.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "Jede Einheit sendet ihren Bericht über ein Konto an TRA. Sie können ein einziges Konto für das gesamte Inserat verwenden oder einigen Einheiten ein anderes zuweisen: Jede RNT steht für eine Unterkunft.",
      introSingle: "Verbinden Sie das Konto, über das dieses Inserat seinen Bericht an TRA sendet.",
      emptyList: "Sie haben noch kein TRA-Konto verbunden.",
      withoutAccountText: "Ihre Aufenthalte werden nicht an TRA gemeldet.",
      newTitle: "Neues TRA-Konto",
      editTitle: "TRA-Konto bearbeiten",
      modalSub: "Das sind der Token und die RNT dieser Unterkunft",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "Fügen Sie hier Ihren Token ein",
      tokenHint: "Sie erzeugen ihn auf",
      loginTitle: "Zugang zu TRA",
      loginSame: "Derselbe Token",
      loginSameHint: "Sie geben nur die RNT dieses Kontos ein.",
      loginOwn: "Anderer Token",
      rntLabel: "RNT",
      rntPlaceholder: "z. B. 123456",
      rntHint: "Das Registro Nacional de Turismo dieser Unterkunft. Damit wird der Betrieb gegenüber TRA identifiziert.",
      aliasHint: "Dient nur dazu, es hier zu erkennen. Bleibt es leer, wird das Konto mit seiner RNT angezeigt.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "nach dem Speichern ohne Konto. Ihre Aufenthalte werden nicht mehr an TRA gemeldet.",
      errToken: "Fügen Sie den TRA-Token ein.",
      errRnt: "Die RNT ist eine Zahl. Bitte prüfen.",
      savedValidated: "Konto gespeichert und von TRA validiert.",
      savedNotValidated: "Gespeichert, aber TRA lehnt die Daten ab. Bitte prüfen.",
      savedUnchecked: "Konto gespeichert. TRA kann den Token nicht vorab prüfen: Das zeigt sich bei der ersten Übermittlung.",
    },

    foreign: {
      ses: "SES Hospedajes (Spanien)",
      colombia: "SIRE und TRA (Kolumbien)",
      title: "Es sind noch {name}-Konten übrig",
      text: "Dieses Inserat liegt nicht mehr in diesem Land, daher meldet dieses Konto nichts. | Dieses Inserat liegt nicht mehr in diesem Land, daher melden diese {count} Konten nichts.",
      remove: "Entfernen",
      removeTitle: "Die übrigen Konten entfernen?",
      removeMessage: "Das übrig gebliebene {name}-Konto wird entfernt. Das wirkt sich nicht auf die Behörde aus, die Sie jetzt nutzen. | Die {count} übrig gebliebenen {name}-Konten werden entfernt. Das wirkt sich nicht auf die Behörde aus, die Sie jetzt nutzen.",
      removed: "Konten entfernt.",
      removeError: "Sie konnten nicht entfernt werden.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "Check-out-Nachricht",
    subtitle: "Eine Check-out-Erinnerung, die am Abend vor der Abreise gesendet wird. Schreiben Sie Ihren eigenen Text und nutzen Sie die verfügbaren Variablen.",
    loading: "Wird geladen…",
    enableTitle: "Check-out-Nachricht senden",
    enableSub: "Sie wird automatisch {day} um {time} gesendet.",
    dayLast: "am Abreisetag",
    dayBefore: "am Tag vor der Abreise",
    cloneTitleNoun: "Check-out-Nachricht",
    cloneItemNoun: "die Check-out-Nachricht",
    whenLabel: "Sendezeitpunkt",
    dayBeforeShort: "Vortag",
    dayLastShort: "Abreisetag",
    atLabel: "Um",
    timeHint: "Am Abreisetag darf die Uhrzeit nicht nach dem Check-out ({time}) liegen.",
    otaTitle: "Auch über die OTA senden",
    textLabel: "Text der Check-out-Nachricht",
    translate: "Übersetzen",
    translating: "Wird übersetzt…",
    attach: "Anhängen",
    uploading: "Wird hochgeladen…",
    attachTitle: "Anhänge der Check-out-Nachricht",
    emojis: "Emojis",
    searchEmoji: "Emoji suchen…",
    variables: "Variablen",
    varsHint: "Zum Einfügen antippen. Beim Senden werden sie durch die echten Daten der Buchung ersetzt.",
    uploadDone: "Gesendet. Wird auf dem Server gespeichert…",
    attachLimits: "Bilder und PDF bis {file} MB · MP4-Videos bis {video} MB.",
    attachLimitsWhy: "Das sind die Grenzwerte, die WhatsApp zulässt.",
    tipBefore: "Verwenden Sie",
    tipTextWord: "Text",
    tipMid: "um etwas",
    tipBoldWord: "fett",
    tipAfter: "zu machen (WhatsApp-Formatierung). Der Gast erhält die Nachricht in seiner Sprache, sofern eingerichtet.",
    attachShared: "Anhänge · für alle Sprachen gemeinsam",
    delete: "Löschen",
    autosaveNote: "Änderungen werden automatisch gespeichert.",
    preview: "Vorschau",
    online: "online",
    previewHint: "Wird mit Ihren Einstellungen aktualisiert",
    dayOfCheckout: "Abreisetag",
    eveOfCheckout: "Vorabend der Abreise",
    yourAccommodation: "Ihre Unterkunft",
    uploadSent: "{sent} von {total} MB",
    filesCount: "{count} Dateien",
    placeholder: "z. B. Hallo {guest} 👋 Ihr Aufenthalt in {property} endet morgen. Check-out ist um {time}. Danke für Ihren Besuch!",
    varGuestName: "Name des Gastes",
    varPropertyName: "Name der Unterkunft",
    varCheckoutTime: "Check-out-Zeit",
    today: "heute",
    tomorrow: "morgen",
    previewDefault: "Hallo *{guest}* 👋\n\nnur eine kurze Erinnerung: Ihr Aufenthalt in *{property}* endet {when}.\n\n🕚 Der späteste Check-out ist um *{time}*.\n\nVielen Dank für Ihren Aufenthalt. Gute Reise! 😊",
    errVideoFormat: "❌ {name} ist ein {ext}-Video und WhatsApp unterstützt nur MP4. Wandeln Sie es in MP4 um und laden Sie es erneut hoch.",
    errFileSize: "❌ {name} hat {size} MB, das Maximum sind {max} MB. ",
    errFileSizeVideo: "WhatsApp unterstützt keine größeren Videos: komprimieren oder kürzen Sie es.",
    errFileSizeFile: "WhatsApp unterstützt keine größeren Dateien.",
    attachUploaded: "Anhang/Anhänge erfolgreich hochgeladen",
    attachUploadError: "Fehler beim Hochladen der Anhänge",
    attachDeleted: "Anhang gelöscht",
    attachDeleteError: "Der Anhang konnte nicht gelöscht werden",
    loadError: "Die Check-out-Nachricht konnte nicht geladen werden.",
    translateEmpty: "Schreiben Sie die Nachricht in der aktiven Sprache, bevor Sie übersetzen.",
    translateSuccess: "{count} Sprachen übersetzt! Prüfen Sie jeden Tab.",
    translatePartial: "{ok} übersetzt, {fail} fehlgeschlagen.",
    translateError: "Übersetzen nicht möglich. Bitte versuchen Sie es erneut.",
    saved: "Check-out-Nachricht gespeichert",
    saveError: "Die Check-out-Nachricht konnte nicht gespeichert werden.",
  },
};
